export const LOGIN_DETAILS='LOGIN_DETAILS';
export const LOGOUT_DETAILS='LOGOUT_DETAILS';
export const MODULE = 'MODULE';
export const FOCUS_TO_SUBHEADER_OF_SEATMANAGEMENT='FOCUS_TO_SUBHEADER_OF_SEATMANAGEMENT';
export const MODULE_AND_LOGINDIV_DISABLED='MODULE_AND_LOGINDIV_DISABLED';
